<template>
	<div>
		<v-container fluid :style="'height: 100vh;background-color:' + $theme.primary">
			<v-layout fill-height>
				<v-row align="center">
					<v-col align="center">
						<v-sheet class="mx-auto" style="width: 400px; padding: 50px" outlined rounded="xl">
							<h3 :style="'color:' + $theme.primary">
								진담헤어
							</h3>
							<br />
							<br />
							<v-btn color="primary" @click="onClickDownload">
								어플 다운받기
							</v-btn>
						</v-sheet>
					</v-col>
				</v-row>
			</v-layout>
		</v-container>
	</div>
</template>

<script>
	export default {
		mounted() {
			this.onClickDownload(); // 버튼 동작 재사용
		},
		methods: {
			onClickDownload() {
				const path = window.location.pathname;
				const params = new URLSearchParams(window.location.search);
				const email = params.get('e');

				const isAndroid = /android/i.test(navigator.userAgent);
				const isiOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;

				console.log('▶︎▶︎▶︎ path', path);
				console.log('▶︎▶︎▶︎ params', params);
				console.log('▶︎▶︎▶︎ email', email);

				if (path === '/d' && email) {
					const appScheme = `jindamhair://d?e=${email}`;
					console.log('appScheme : ' + appScheme);

					window.location = appScheme;

					setTimeout(() => {
						if (isAndroid) {
							window.location = 'https://play.google.com/store/apps/details?id=com.flynnapps.jindamhair';
						} else if (isiOS) {
							window.location = 'https://apps.apple.com/app/1619262794';
						} else {
							console.log('setTimeout > not android & ios');
							window.location = 'https://play.google.com/store/apps/details?id=com.flynnapps.jindamhair';
						}
					}, 1000);
				} else {
					// 일반 접근자는 스토어로
					if (isAndroid) {
						window.location = 'https://play.google.com/store/apps/details?id=com.flynnapps.jindamhair';
					} else if (isiOS) {
						window.location = 'https://apps.apple.com/app/1619262794';
					} else {
						console.log('not android & ios');
						window.location = 'https://play.google.com/store/apps/details?id=com.flynnapps.jindamhair';
					}
				}
			},
		},
	};
</script>

<style scoped></style>
